export default __webpack_public_path__ + "static/media/logo.493535e9.png";